import React, {useEffect, useState} from 'react';
import {Button, Col, Flex, notification, Row} from "antd";
import RentFormPopUp from "./rentFormPopUp/RentFormPopUp";
import CallInformationPopUp from "./callInformationPopUp/CallInformationPopUp";
import {RentFormProps} from "../../models";
import {useNavigate} from "react-router-dom";
import {setValue} from "../../../../shared/slice/CurrentUser.slice";
import {connect} from "react-redux";
import {getProductDetail} from "../../actions/Product.action";
import {withRouter} from "../../../../utils/services/with-router";
import {getUser} from "../../../../shared";
import VerifyIdentityPopup from "../../../../shared/components/verifyIdentity/VerifyIdentityPopup";

const RentForm = ({product,getUser} : RentFormProps) => {
    const [open, setOpen] = useState<boolean>(false)
    const [openCallInfoPopUp, setOpenCallInfoPopUp] = useState<boolean>(false)
    const navigate = useNavigate()
    const [openVerificationModal, setOpenVerificationModal] = useState<boolean>(false);

    const onCansel = () => {
        setOpen(false)
        setOpenVerificationModal(false)
        setOpenCallInfoPopUp(false)
    }
    const onHandleOk = () => {
        _getUserInfo()
        setOpenVerificationModal(false)
    }
    const _getUserInfo = () => {
        if (!!localStorage.getItem("jwt")){
            getUser()
                .then((data: any) => {
                    if (data.payload) {
                        let isVerified = data.payload.data?.isAuthenticated;
                        if(product?.isBorrowRequestPossible && isVerified)
                            setOpen(true)
                        else
                        if (!product?.isBorrowRequestPossible)
                            notification.warning({message:"برای این محصول قبلا توسط شما درخواست ارسال شده است" })
                        else
                        if (!isVerified) {
                            window.scrollTo({
                                top: 0,
                            });
                            setOpenVerificationModal(true)
                        }

                    }
                })
                .catch();
        } else {navigate("/login")}
    };

    return (
        <Flex justify={"center"} gap={"middle"}>
            <Col xs={12} sm={12} md={12} lg={12} xl={12}>

                <Button disabled={product?.productStatus?.id !== 1} size={"large"} block type="primary" onClick={() =>{
                    _getUserInfo()}}>همین حالا اجاره کن</Button>
            </Col>
            <Col xs={12} sm={12} md={12} lg={12} xl={12}>

                <Button size={"large"} block onClick={() => {

                    if (!!localStorage.getItem("jwt"))
                    setOpenCallInfoPopUp(true)
                    else navigate("/login")
                }
                }>اطلاعات تماس</Button>
            </Col>
            <RentFormPopUp open={open} onCansel={onCansel}/>
            {openCallInfoPopUp && <CallInformationPopUp open={openCallInfoPopUp} onCansel={onCansel}/>}
            { openVerificationModal && <VerifyIdentityPopup open={openVerificationModal} onHandleCancel={onCansel} onHandleOk={onHandleOk}/>}
        </Flex>
    );
};

export default connect(null, {getUser})(withRouter(RentForm));
